module.exports = __webpack_public_path__ + "static/img/p1-3.cf6f2fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-3.png
// module id = DmhG
// module chunks = 0